import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import NotFound from '../views/404.vue';
import VueMeta from 'vue-meta'

Vue.use(VueRouter)
Vue.use(VueMeta)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/app',
    name: 'app',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "app-chunk" */ '../views/App.vue'),
    metaInfo: {
      title: 'App | Wersa',
    }
  },
  {
    path: '/my-code',
    name: 'my-code',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "mycode-chunk" */ '../views/MyCode.vue'),
    metaInfo: {
      title: 'App | Wersa',
    }
  },
  {
    path: '/best',
    name: 'best',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "best-chunk" */ '../views/MyCode.vue'),
    metaInfo: {
      title: 'App | Wersa',
    }
  },
  {
    path: '/resources',
    name: 'resources',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "resources-chunk" */ '../views/Resources.vue'),
    metaInfo: {
      title: 'Developers\' Resources | Wersa',
    }
  },
  {
    path: '/help-support',
    name: 'help-support',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "help-chunk" */ '../views/Help.vue'),
    metaInfo: {
      title: 'Help & Support | Wersa',
    }
  },
  {
    path: '/privacy-policy-and-terms-of-use',
    name: 'privacy-policy-and-terms-of-use',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "privacy-policy-and-terms-of-use-chunk" */ '../views/PPTU.vue'),
    metaInfo: {
      title: 'Privacy policy and Terms of use | Wersa',
      meta: [
        {name: 'robots', content: 'noindex'} 
      ]
    }
  },
  {
    path: '*',
    component: NotFound,
    meta: {
      title: 'File not found | Wersa',
    }
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router